var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5H5C3.9 8.5 3 7.6 3 6.5C3 5.4 3.9 4.5 5 4.5H19C20.1 4.5 21 5.4 21 6.5C21 7.6 20.1 8.5 19 8.5ZM19 10.5H5C3.9 10.5 3 11.4 3 12.5C3 13.6 3.9 14.5 5 14.5H19C20.1 14.5 21 13.6 21 12.5C21 11.4 20.1 10.5 19 10.5ZM19 16.5H5C3.9 16.5 3 17.4 3 18.5C3 19.6 3.9 20.5 5 20.5H19C20.1 20.5 21 19.6 21 18.5C21 17.4 20.1 16.5 19 16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerNav);
export default __webpack_public_path__ + "static/media/hamburger-nav.88cc3054444bacf4471bcee129251272.svg";
export { ForwardRef as ReactComponent };